/* eslint-disable no-tabs */
/* eslint-disable max-len */
import '../../../assets/css/pages/product.css';
import {
  // eslint-disable-next-line max-len
  serverDate, busPeriodStart, busPeriodEnd,
} from '../../utils/common';

const busMain = document.getElementById('busMain');

function loadLayout() {
  busMain.innerHTML = `
	<div class="title_box">
		 <span>홈</span>
		 <p></p>
		 <span>참가 신청</span>
		 <p></p>
		 <span id="active_page">마라톤 버스 예약</span>
 </div>
 <span class="title_text">마라톤 버스 예약</span>
 <div class="container mobile_border">
		 <form id="form" class="form">
				 <div class="form-control">
						 <div class="title_area">
								 <span class="text01">버스 예약 정보</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">접수 시작</span>
								 <span class="confirm_text_type">2026년 7월 27일(월) 10시~</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">접수 방법</span>
								 <span class="confirm_text_type">온라인 접수 (신청확인 페이지에서 정보 조회 후 신청)</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">좌석 수량</span>
								 <span class="confirm_text_type mgr-sm-6">2,500석</span>
								 <span class="font-sm red_type" style="font-size: 14px; font-weight: 400; line-height: 20px;">※ 선착순 마감</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">신청 대상</span>
								 <span class="confirm_text_type">2026년 춘천마라톤 신청 및 결제 완료자</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">신청 수량</span>
								 <span class="confirm_text_type">1인당 최대 1매까지 가능</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">버스 요금</span>
								 <span class="confirm_text_type">25,000원 (왕복)</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">환불 기간</span>
								 <span class="confirm_text_type">~9월 23일(수) 17:59</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text confirm_text_type fnt-wet-bg">출발 일시</span>
								 <span class="confirm_text_type">(서울 각 지역) 대회일 오전 6시</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text_type2 confirm_text_type fnt-wet-bg">운행 안내</span>
								 <span class="confirm_text_type">[서울 → 춘천]<br>각 장소에서 오전 6시 일괄 출발</span><br><br>
								 <span class="confirm_text_type mgl-bg-2">[춘천 → 서울]</span><br>
								 <span class="confirm_text_type mgl-bg-2">공지천에서 오후 2시 30분~오후 4시</span><br>
								 <span class="confirm_text_type mgl-bg-2">만차 순서대로 출발, 서울에서 출발한 장소에 도착</span>
						 </div>
						 <div class="form_detail">
								 <span class="form_text_type2 confirm_text_type fnt-wet-bg">탑승 안내</span>
								 <div class="flex_box3 bus_border">
										 <img src="//image.chosun.com/chuncheonmarathon/2023/bus_img1.png">
										 <span class="confirm_text_type mgl-sm-2">1호선/2호선 시청역 2번 출구<br>5호선 광화문역 6번 출구 서울광장 건너편</span>
								 </div>
								 <div class="flex_box3 bus_border mgl-bg-2">
										 <img src="//image.chosun.com/chuncheonmarathon/2023/bus_img2.png">
										 <span class="confirm_text_type mgl-sm-2">2호선 잠실 종합운동장역 6번 출구 앞</span>
								 </div>
								 <div class="flex_box3 bus_border mgl-bg-2">
										 <img src="//image.chosun.com/chuncheonmarathon/2023/bus_img3.png">
										 <span class="confirm_text_type mgl-sm-2">1호선/2호선 신도림역 1번 출구 횡단보도 건너,<br>
												 푸르지오 2차 상가 정문 앞</span>
								 </div>
								 <div class="flex_box3 mgl-bg-2">
										 <img src="//image.chosun.com/chuncheonmarathon/2023/bus_img4.png">
										 <span class="confirm_text_type mgl-sm-2">2호선/4호선 사당역 12번 출구 버스정류장 앞</span>
								 </div>
						 </div>
				 </div>
				 <div class="pr_nx_btn">
						 <a href="../apply/part-confirm.html" class="btn_nx" type="button" onclick="particle()">예약하기</a>
				 </div>
		 </form>
 </div>`;
}

document.addEventListener('DOMContentLoaded', () => {
  const setReadyPage = (text) => {
    busMain.innerHTML = `
			<div class="ready">
				<div class="ready_img_wrap">
					<img src="https://image.chosun.com/chuncheonmarathon/2024/ready_img.png" alt="chuncheonmarathon">
					<span class="text text-center">${text}</span>
				</div>
			</div>
		`;
  };

  const isNotInPeriod = (start, end) => serverDate() < start || serverDate() > end;

  const busPeriodMap = {
    period: [busPeriodStart, busPeriodEnd],
    // eslint-disable-next-line quotes
    // message: `마라톤 버스 예약은 '2026 춘천마라톤 접수 완료자'에 한해\n7/27(월) 10시부터 선착순 접수 예정입니다.`,
    message: '마라톤 버스 예약이 마감되었습니다. 마라톤 버스 예약 내역은 [신청확인/결제] 메뉴에서 확인 가능합니다.',
  };

  if (isNotInPeriod(...busPeriodMap.period)) {
    setReadyPage(busPeriodMap.message);
    return;
  }

  loadLayout();
});
